import { forwardRef } from 'react';
import { StyledStrong } from './styled';

const Strong = forwardRef((props, ref) => (
  <StyledStrong ref={ref} {...props} />
));

export default Strong;
